<!-- Tabella con lista filtrata -->
<div>
  <ds-table
    [columns]="tableColumns()"
    [options]="tableOptions()"
    [sourceList]="tablePsCustomers()"
    [(selectedRecords)]="selectedRecords"
    [isLoading]="loading()"
  />
</div>

<ng-template #tooltipPSCompleteStatus let-row="row">
  @let customerErrors = getCustomerErrors(row.id);

  <p>
    <b>{{ translation.errorsProfileRegistry }}</b>
  </p>
  @for (customerError of customerErrors; track $index) {
    <div>
      <span>{{ customerError.name }}:</span>
      <ul>
        @for (error of customerError.errors; track $index) {
          @if (error) {
            <li>{{ translationService.translateError(error) }}</li>
          }
        }
      </ul>
      <br />
    </div>
  }
</ng-template>

<ng-template #tooltipPSSentError let-row="row">
  @let purchasedStayToCustomer = row.purchasedStayToCustomer;
  <div>
    <b>{{ translation.publicSecurityStatusSentError }}</b>
    <ul>
      <li>{{ translation.psErrorCode }}: {{ purchasedStayToCustomer.psErrorCode }}</li>
      <li>{{ translation.psErrorDescription }}: {{ purchasedStayToCustomer.psErrorDescription }}</li>
      <li>{{ translation.psErrorDetail }}: {{ purchasedStayToCustomer.psErrorDetail }}</li>
    </ul>
    <br />
  </div>
</ng-template>

<ng-template #psCompleteStatus let-value="value" let-row="row">
  <ds-status-label
    [text]="value ? translation.completeStatus : translation.incompleteStatus"
    [status]="value ? 'confirm' : 'danger'"
    [tooltipTrigger]="value ? 'hover' : 'click'"
    [tooltip]="!value ? tooltipPSCompleteStatus : undefined"
    [tooltipContext]="{ row: row }"
    [disabled]="value"
    showIcon
    small
  />
</ng-template>

<ng-template #psStateStatus let-value="value" let-row="row">
  <ds-status-label
    [text]="getTextByPublicSecurityStatus(value)"
    [status]="getStatusByPublicSecurityStatus(value)"
    [tooltipTrigger]="getTextByPublicSecurityStatus(value) === publicSecurityStatus.SentError ? 'click' : 'hover'"
    [tooltip]="value === publicSecurityStatus.SentError ? tooltipPSSentError : undefined"
    [tooltipContext]="{ row: row }"
    [disabled]="value !== publicSecurityStatus.SentError"
    showIcon
    small
  />
</ng-template>
